import { postActivitiesQuery } from '@client-shared/api/activities.api.js'

export default {
  namespaced: true,

  state () {
    return {
      list: [],
      latestQueryToken: 0,
      inlinePlanActivitiesRefreshToken: 0,
      inlineDocumentActivitiesRefreshToken: 0,
      inlineTaskActivitiesRefreshToken: 0,
    }
  },

  mutations: {
    SET_ACTIVITIES (state, activities) {
      state.list = activities
    },

    INCREMENT_QUERY_TOKEN (state) {
      state.latestQueryToken += 1
    },

    INCREMENT_INLINE_PLAN_ACTIVITIES_REFRESH_TOKEN (state) {
      state.inlinePlanActivitiesRefreshToken += 1
    },

    INCREMENT_INLINE_DOCUMENT_ACTIVITIES_REFRESH_TOKEN (state) {
      state.inlineDocumentActivitiesRefreshToken += 1
    },

    INCREMENT_INLINE_TASK_ACTIVITIES_REFRESH_TOKEN (state) {
      state.inlineTaskActivitiesRefreshToken += 1
    },

    FULL_RESET (state) {
      state.list = []
      // Invalidate in-flight queries, so a response for the project we just left
      // can't repopulate the list after the reset.
      state.latestQueryToken += 1
    },
  },

  actions: {
    async queryActivities ({ commit, state, rootState, rootGetters }, { projectId }) {
      commit('INCREMENT_QUERY_TOKEN')

      const queryToken = state.latestQueryToken

      const activities = await postActivitiesQuery({
        axios: this.$axios,
        projectId,
        query: {
          ...rootState.activitiesFilter,
          startDate: rootGetters['activitiesFilter/getDateRange'].start,
          endDate: rootGetters['activitiesFilter/getDateRange'].end,
        },
      })

      // Another query was started while this one was in flight (filter change, websocket
      // reconnect refetch, route guard). That newer query matches the filters the user is
      // looking at, so discard this older response instead of clobbering the list with a
      // result that no longer matches the filter UI.
      if (queryToken !== state.latestQueryToken) {
        return
      }

      commit('SET_ACTIVITIES', activities)
    },
  },
}
